import React from 'react';
import { string, node } from 'prop-types';
import useStyles from 'hooks/useStyles';

import styles from './PaymentOptionGroup.scss';

export default function PaymentOptionGroup({ title, children }) {
  useStyles(styles);

  if (children.filter(Boolean).length === 0) return null;

  return (
    <div className={styles.root}>
      {title && <h2 className={styles.title}>{title}</h2>}
      {children}
    </div>
  );
}

PaymentOptionGroup.propTypes = {
  title: string,
  children: node,
};

PaymentOptionGroup.defaultProps = {
  title: undefined,
  children: undefined,
};
